import React, { createContext, useContext } from 'react'
import { Badge, Space } from 'antd'
import { useQuery } from '@apollo/client'
import { DesktopOutlined } from '@ant-design/icons'
import { MenuLink } from '../../../core/until'
import { translate } from '../../../core'
import { ShowIf } from '../../../core/component'
import { GetNewOrderCountQuery } from '../graphql/order-queries.graphql'

// Same refresh as the received back orders badge, so every open workstation
// picks up website orders without a page reload.
const POLL_INTERVAL = 60_000

type OnlineOrderCount = {
  count: number
  refetch: () => void
}

const OnlineOrderCountContext = createContext<OnlineOrderCount>({
  count: 0,
  refetch: () => undefined,
})

export const OnlineOrderCountProvider = ({children}: { children: React.ReactNode }) => {
  const {data, refetch} = useQuery(GetNewOrderCountQuery, {
    pollInterval: POLL_INTERVAL,
  })

  return (
    <OnlineOrderCountContext.Provider
      value={{
        count: data?.onlineOrderNewCount ?? 0,
        refetch: () => { refetch() },
      }}
    >
      {children}
    </OnlineOrderCountContext.Provider>
  )
}

export const useOnlineOrderCount = () => useContext(OnlineOrderCountContext)

export const OnlineOrderMenuItem = () => {
  const {count} = useOnlineOrderCount()

  return (
    <Space>
      <MenuLink
        title={translate('online', 'order')}
        to='/online-orders'
      />
      <ShowIf
        condition={!!count}
        replacement={<></>}
      >
        <Badge count={count} color='#f5222d'/>
      </ShowIf>
    </Space>
  )
}

export const OnlineOrderMenuIcon = () => {
  const {count} = useOnlineOrderCount()

  return (
    <DesktopOutlined style={{fontSize: 23, color: count > 0 ? '#f5222d' : '#a3bde3'}}/>
  )
}
